import { Popover } from '@chakra-ui/react'

import PopoverTrigger from './PopoverTrigger'
import PopoverContent from './PopoverContent'
import PopoverBody from './PopoverBody'

export { PopoverTrigger, PopoverContent, PopoverBody }

export default Popover
